import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] border-t border-[#B8860B]/10">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo e Descrição */}
          <div className="space-y-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_texas-bbq-admin/artifacts/nmt6zdvd_Design%20sem%20nome.png" 
              alt="Santa Carne BBQ" 
              className="h-24 w-auto"
            />
            <p className="text-[#E8DDCB]/60 text-sm leading-relaxed">
              Fábrica artesanal de carnes defumadas. Respeito pelo tempo, paixão pela carne.
            </p>
          </div>

          {/* Links Rápidos */}
          <div>
            <h3 className="text-[#E8DDCB] font-semibold text-sm tracking-widest uppercase mb-6">Menu</h3>
            <ul className="space-y-3">
              {[
                { label: 'A Santa Carne', path: '/' },
                { label: 'Parceiros', path: '/parceiros' },
                { label: 'Produtos', path: '/produtos' },
                { label: 'Catálogo', path: '/catalogo' },
                { label: 'Contacto', path: '/contacto' },
                { label: 'FAQ', path: '/faq' },
                { label: 'Política de Privacidade', path: '/politica-privacidade' }
              ].map((item) => (
                <li key={item.path}>
                  <Link 
                    to={item.path} 
                    className="text-[#E8DDCB]/60 hover:text-[#B8860B] transition-colors text-sm"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contacto */}
          <div>
            <h3 className="text-[#E8DDCB] font-semibold text-sm tracking-widest uppercase mb-6">Contacto</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0 text-[#B8860B]" />
                <p className="text-[#E8DDCB]/60 text-sm">
                  Rua das laranjeiras, 14<br/>Mafra - PT 2640-577
                </p>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-4 h-4 text-[#B8860B]" />
                <p className="text-[#E8DDCB]/60 text-sm">+351 918 288 122</p>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-4 h-4 text-[#B8860B]" />
                <p className="text-[#E8DDCB]/60 text-sm">geralsantacarne@gmail.com</p>
              </li>
            </ul>
          </div>

          {/* Redes Sociais */}
          <div>
            <h3 className="text-[#E8DDCB] font-semibold text-sm tracking-widest uppercase mb-6">Siga-nos</h3>
            <p className="text-[#E8DDCB]/60 text-sm mb-6">
              Acompanhe as nossas novidades.
            </p>
            <div className="flex space-x-3">
              <a
                href="https://www.instagram.com/santacarnebbq/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-[#B8860B]/30 flex items-center justify-center text-[#B8860B] hover:bg-[#B8860B] hover:text-[#1a1a1a] transition-all"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="https://www.facebook.com/santacarnebbq/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full border border-[#B8860B]/30 flex items-center justify-center text-[#B8860B] hover:bg-[#B8860B] hover:text-[#1a1a1a] transition-all"
              >
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-[#B8860B]/10 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#E8DDCB]/40 text-xs tracking-wider">
            © {new Date().getFullYear()} SANTA CARNE BBQ. Todos os direitos reservados.
          </p>
          <Link 
            to="/admin/login"
            className="text-[#E8DDCB]/30 hover:text-[#B8860B] text-xs tracking-wider transition-colors"
          >
            ADMIN
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
